import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Package } from 'lucide-react';

const NotFound = () => {
  const quickLinks = [
    { path: '/', name: 'Ana Sayfa', icon: <Home className="h-5 w-5" /> },
    { path: '/products', name: 'Ürünler', icon: <Package className="h-5 w-5" /> },
    { path: '/recipes', name: 'Tarifler', icon: <Search className="h-5 w-5" /> },
    { path: '/contact', name: 'İletişim', icon: <ArrowLeft className="h-5 w-5" /> },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-green-50 flex items-center justify-center px-4 py-20">
      <div className="max-w-4xl mx-auto text-center">
        {/* 404 Animation */}
        <div className="relative mb-12">
          <div className="text-[200px] md:text-[300px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#216DB8] to-green-600 leading-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-bounce">
              <svg 
                className="w-32 h-32 text-[#216DB8]" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
          Sayfa Bulunamadı
        </h1>
        <p className="text-xl text-gray-600 mb-4">
          Üzgünüz! Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
        <p className="text-lg text-gray-500 mb-12">
          Ancak endişelenmeyin, size yardımcı olacak birkaç seçenek var! 🎯
        </p>

        {/* Quick Links */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {quickLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all hover:-translate-y-2 group"
            >
              <div className="bg-gradient-to-br from-[#216DB8] to-green-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                {link.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-800 group-hover:text-[#216DB8] transition-colors">
                {link.name}
              </h3>
            </Link>
          ))}
        </div>

        {/* Back to Home Button */}
        <Link 
          to="/"
          className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#216DB8] to-green-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all hover:scale-105"
        >
          <Home className="h-5 w-5" />
          <span>Ana Sayfaya Dön</span>
        </Link>

        {/* Fun Message */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 max-w-2xl mx-auto">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="bg-blue-100 rounded-full p-3">
                <svg 
                  className="w-6 h-6 text-[#216DB8]"
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                  />
                </svg>
              </div>
            </div>
            <div className="text-left">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Yardıma mı ihtiyacınız var?
              </h3>
              <p className="text-gray-600">
                Aramak istediğiniz bir şey mi var? Ürünlerimize göz atabilir veya 
                bizimle iletişime geçebilirsiniz. Size yardımcı olmaktan mutluluk duyarız! 😊
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <Link 
                  to="/products"
                  className="text-[#216DB8] hover:text-green-600 font-medium transition-colors"
                >
                  Ürünleri İncele →
                </Link>
                <Link 
                  to="/contact"
                  className="text-[#216DB8] hover:text-green-600 font-medium transition-colors"
                >
                  İletişime Geç →
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Fun Illustration */}
        <div className="mt-12 text-gray-400 text-sm">
          <p>Belki de bu sayfaya süt dökmüş olabiliriz... 🥛</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
